import axios, { all } from "axios";

class Connection {
    HEADERS = null;
    baseURL = "https://api.kharazienika.ir";
    //baseURL = "https://servertest.kharazienika.ir";
    // baseURL = "http://37.156.145.155:2500";
    // baseURL = "http://localhost:2500";
    _axios = axios.create({ baseURL: this.baseURL });

    setCreds(mobile, token) {
        this.HEADERS = new axios.AxiosHeaders().setAuthorization(
            JSON.stringify({ mobile, token })
        );
        this._axios.defaults.headers = this.HEADERS;
    }

    signup(mobile, password) {
        return new Promise((resolve, reject) => {
            this._axios
                .put("users", { mobile, password })
                .then(resolve)
                .catch(reject);
        });
    }

    login(mobile, password) {
        return new Promise((resolve, reject) => {
            this._axios
                .post("users/login", { mobile, password })
                .then((res) => {
                    let { mobile, token } = res.data;
                    this.setCreds(mobile, token);

                    resolve(res);
                })
                .catch(reject);
        });
    }

    validateToken(mobile, token) {
        return new Promise((resolve, reject) => {
            let headers = new axios.AxiosHeaders().setAuthorization(
                JSON.stringify({ mobile, token })
            );
            this._axios
                .get("/users/validateToken", {
                    headers,
                })
                .then((res) => {
                    this.setCreds(mobile, token);
                    resolve(res);
                })
                .catch((err) => {
                    this.HEADERS = null;
                    reject(err);
                });
        });
    }

    get_all_special_offers() {
        return this.get_filtered_data("items", { is_special_offer: true });
    }

    get_best_sellers(count) {
        return this.get_filtered_data("items", null, "sold_count", count);
    }

    get_newest_items(count) {
        return this.get_filtered_data("items", null, "add_time", count);
    }

    get_all_suggestions() {
        return new Promise((resolve, reject) => {
            this._axios
                .get("items?is_suggestion=true")
                .then(resolve)
                .catch(reject);
        });
    }

    get_item(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("items/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    get_related_items(id, count = "all") {
        return new Promise((resolve, reject) => {
            this._axios
                .get(`items/${id}/related/${count}`)
                .then(resolve)
                .catch(reject);
        });
    }

    get_costs() {
        return new Promise((resolve, reject) => {
            this._axios.get(`costs`).then(resolve).catch(reject);
        });
    }

    get_main_page_Banners() {
        return new Promise((resolve, reject) => {
            this._axios.get("mainPageBanners").then(resolve).catch(reject);
        });
    }

    get_all_categories() {
        return new Promise((resolve, reject) => {
            this._axios.get("categories").then(resolve).catch(reject);
        });
    }

    get_filtered_data(
        type /*items/orders/users/tickets*/,
        query = null,
        sort = null,
        count = null,
        reverseSort = false,
        page = null
    ) {
        query = query || {};
        sort && (query.sort = sort);
        count && (query.count = count);
        reverseSort && (query.reverseSort = reverseSort);
        page && (query.page = page);

        let queryString = "?";
        let queryKeys = query && Object.keys(query);
        if (query && queryKeys.length > 0) {
            queryKeys
                .filter((k) => {
                    const q = query[k];

                    return (
                        (q &&
                            (typeof q === "object" ? q.length !== 0 : true)) ||
                        q === 0
                    );
                })
                .forEach((key) => {
                    queryString += `${key}=${
                        typeof query[key] === "string"
                            ? query[key]
                            : JSON.stringify(query[key])
                    }&`;
                });
        }

        return new Promise((resolve, reject) => {
            this._axios
                .get(`/${type}/${queryString}`)
                .then(resolve)
                .catch(reject);
        });
    }

    get_costumer() {
        return new Promise((resolve, reject) => {
            this._axios.get("users/").then(resolve).catch(reject);
        });
    }

    get_shipping_info() {
        return new Promise((resolve, reject) => {
            this._axios
                .get("users/get_shipping_info")
                .then(resolve)
                .catch(reject);
        });
    }

    put_comment(comment) {
        return new Promise((resolve, reject) => {
            this._axios.put("comments", comment).then(resolve).catch(reject);
        });
    }

    user_action_on_item(action, id, set) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch(`users/${action}/${id}/${set}`)
                .then(resolve)
                .catch(reject);
        });
    }

    can_costumer_comment_on(item_id) {
        return new Promise((resolve, reject) => {
            if (!this.HEADERS) {
                reject();
                return;
            }
            this._axios
                .get(`users/can_comment/` + item_id)
                .then(resolve)
                .catch(reject);
        });
    }

    update_cart(cart) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("users/update_cart", cart)
                .then(resolve)
                .catch(reject);
        });
    }

    check_cart(cart) {
        return new Promise((resolve, reject) => {
            this._axios.post("checkout", cart).then(resolve).catch(reject);
        });
    }

    get_shipping_cost(weight, method, province_code = 0, coupon) {
        return new Promise((resolve, reject) => {
            this._axios
                .post("/orders/shipping_cost", {
                    weight,
                    method,
                    province_code,
                    coupon,
                })
                .then(resolve)
                .catch(reject);
        });
    }

    get_cities() {
        return new Promise((resolve, reject) => {
            this._axios.get("/post/get_cities").then(resolve).catch(reject);
        });
    }

    order(order) {
        return new Promise((resolve, reject) => {
            this._axios.put("/orders", order).then(resolve).catch(reject);
        });
    }

    order_follow_up(id, mobile) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/orders/follow-up/" + id + "/" + mobile)
                .then(resolve)
                .catch(reject);
        });
    }

    get_offline_payment_methods() {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/offlinePaymentMethods")
                .then(resolve)
                .catch(reject);
        });
    }

    order_exists(id, mobile) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/orders/exists/" + id + "/" + mobile)
                .then(resolve)
                .catch(reject);
        });
    }

    get_orders(count, page) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/orders?count=" + count + "&&page=" + page)
                .then(resolve)
                .catch(reject);
        });
    }

    submit_offline_payment(data) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/orders/submit_offline_payment", data)
                .then(resolve)
                .catch(reject);
        });
    }

    edit_costumer_info(info) {
        return new Promise((resolve, reject) => {
            this._axios.patch("/users/edit", info).then(resolve).catch(reject);
        });
    }

    log_out() {
        return new Promise((resolve, reject) => {
            this._axios.get("/logout").then(resolve).catch(reject);
        });
    }

    new_ticket(ticket) {
        return new Promise((resolve, reject) => {
            this._axios.put("/tickets", ticket).then(resolve).catch(reject);
        });
    }

    append_message_to_ticket(ticket_id, message) {
        return new Promise((resolve, reject) => {
            this._axios
                .patch("/tickets/" + ticket_id + "/new_message", message)
                .then(resolve)
                .catch(reject);
        });
    }

    get_tickets(count, page) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/tickets?count=" + count + "&&page=" + page)
                .then(resolve)
                .catch(reject);
        });
    }

    get_ticket(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/tickets?id=" + id + "&&setRead=true")
                .then(resolve)
                .catch(reject);
        });
    }

    upload(files, callback) {
        return new Promise((resolve, reject) => {
            let results = [];
            let requests = [];
            files.forEach((file) => {
                let form = new FormData();
                form.append("file", file.file);
                requests.push(
                    this._axios
                        .put("/files", form)
                        .then((result) => {
                            results.push(result.data);
                            callback(results, requests);
                            if (results.length === files.length)
                                resolve(results);
                        })
                        .catch(reject)
                );
            });
        });
    }

    get_contact_info() {
        return new Promise((resolve, reject) => {
            this._axios.get("/contactInfo").then(resolve).catch(reject);
        });
    }

    verify_online_payment(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/orders/verify_online_payment/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    create_online_payment_session(id) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/orders/create_online_payment_session/" + id)
                .then(resolve)
                .catch(reject);
        });
    }

    get_favorites() {
        return new Promise((resolve, reject) => {
            this._axios.get("/users/favorites").then(resolve).catch(reject);
        });
    }

    get_stories() {
        return new Promise((resolve, reject) => {
            this._axios.get("/stories").then(resolve).catch(reject);
        });
    }

    get_tiles() {
        return new Promise((resolve, reject) => {
            this._axios.get("/tiles").then(resolve).catch(reject);
        });
    }

    request_verification_code(mode, mobile) {
        return new Promise((resolve, reject) => {
            this._axios
                .get(`/users/verify-number/${mode}/send-code/${mobile}`)
                .then(resolve)
                .catch(reject);
        });
    }

    send_verification_code(mode, code) {
        return new Promise((resolve, reject) => {
            this._axios
                .post("/users/verify-number/" + mode, code)
                .then(resolve)
                .catch(reject);
        });
    }

    subscribe_notifications(subscription) {
        return new Promise((resolve, reject) => {
            this._axios
                .post("/users/subscribeNotifs", subscription)
                .then(resolve)
                .catch(reject);
        });
    }

    is_notifications_subscribed(subscription) {
        return new Promise((resolve, reject) => {
            this._axios
                .get("/users/subscribeNotifs", subscription)
                .then(resolve)
                .catch(reject);
        });
    }

    change_pass(mobile, code, password) {
        return new Promise((resolve, reject) => {
            this._axios
                .post(`/users/change-pass/`, { mobile, code, password })
                .then(resolve)
                .catch(reject);
        });
    }
}

export default Connection;
